import OKeyboardKey from './o-keyboard-key.vue';

export default OKeyboardKey;